module.exports = __webpack_public_path__ + "img/2024-01_student-success.d8521654.jpg";